




























import Vue from 'vue'
import { ProgressBarElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ProgressBarEl',

  props: {
    templateItemData: {
      type: Object as () => ProgressBarElInterface,
      required: true
    }
  }
})
